import { client } from "../../../api/axiosConfig";

export const getPaymentRecord = (userId) => {
  return client.get(`/get-payment-record/${userId}`);
};
